/**
 * by Aleksandar Panic
 **/
import {sendGet, sendPost} from "./base";

export function getPendingActions() {
    return sendGet('login/pending-actions');
}

export function resolveLoginAction({action, data}) {
    return sendPost('login/resolve-action', {action, data});
}

export function getUserMfaData() {
    return sendGet('login/user-mfa');
}

export function sendLogoutRequest() {
    return sendPost('login/logout');
}

export function requestMfaCode({ phone_number, type }) {
    return sendPost('login/request-mfa-code', { phone_number, type });
}